import React from "react";
import { translate } from "../../utils/translations/translate";
import { StyledRightContainer } from "./styles";
import { Table } from "../UI/Table";
import { ProjectListFilters } from "./ProjectListFilter";
import { useProjectsList } from "./utils/hooks/useProjectsList";
import { Alert } from "../UI/Alert";
import { Loader } from "../Loader/Loader";
import { DeleteConfirmationModal } from "../Settings/DeleteConfirmationModal";
const ProjectsList = () => {
  const {
    isLoading,
    projectsList,
    columnDefs,
    projectKey,
    setProjectKey,
    resourceKey,
    setResourceKey,
    statusKey,
    setStatusKey,
    pageNumber,
    pageSize,
    handlePaginationChange,
    totalRecords,
    downloadDataForReportsGeneration,
    toastInfo,
    gridRef,
    handleToastClose,
    selectedRecords,
    handleGridRowSelection,
    showDeleteModal,
    beforeDeleteProject,
    handleDeletePopupClose,
    onDeleteProject,
  } = useProjectsList();
  return (
    <StyledRightContainer>
      {toastInfo && <Alert {...toastInfo} onToastClose={handleToastClose} />}
      <h1>{translate("pageTitles.projectManagement")}</h1>
      <ProjectListFilters
        projectKey={projectKey}
        setProjectKey={setProjectKey}
        setResourceKey={setResourceKey}
        setStatusKey={setStatusKey}
        resourceKey={resourceKey}
        statusKey={statusKey}
        onReportsClick={downloadDataForReportsGeneration}
        currentRecordsLength={projectsList.length}
        selectedRecordsLength={selectedRecords.length}
        onDeleteAction={beforeDeleteProject}
      />
      <div className="tma__table-container projectList">
        <Table
          columns={columnDefs}
          rowData={projectsList}
          showPagination={true}
          currentPage={pageNumber}
          pageSize={pageSize}
          gridRef={gridRef}
          totalRecords={totalRecords}
          onPaginationChange={handlePaginationChange}
          onRowSelected={handleGridRowSelection}
        />
      </div>
      {isLoading && <Loader />}
      {showDeleteModal && (
        <>
          <DeleteConfirmationModal
            title={translate("labels.deletePrjTitle")}
            infoText={translate("labels.deletePrjInfoText")}
            onClose={handleDeletePopupClose}
            onConfirm={onDeleteProject}
          />
        </>
      )}
    </StyledRightContainer>
  );
};

export { ProjectsList };
